import { Container, Image } from './styles'

type Props = {
  url: string;
  bg?: string;
  imgSize?: object;
}

const ImageEllipse = ({ url, bg, imgSize = { width: null, height: null } }: Props) => {
  return (
    <Container bg={bg}>
      <Image src={url} $imgSize={imgSize}/>
    </Container>
  )
}

export default ImageEllipse
